import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type DSPClientImportRow } from "../../../zodios/apiDefinitions/api/dspClients";
import { useAppSelector } from "../../../redux/hooks";

const DSP_CLIENT_PREVIEW_QUERY_KEY = "dspClientPreview";

const emptyRows: DSPClientImportRow[] = [];

export const useDSPClientPreview = (enabled: boolean) => {
  const orgId = useAppSelector((state) => state.user.organization_id);

  const query = useQuery({
    queryKey: [DSP_CLIENT_PREVIEW_QUERY_KEY, orgId],
    queryFn: async () => await apiClient.previewDSPClients({ queries: { org: orgId } }),
    enabled: enabled && !!orgId,
  });

  return { ...query, rows: query.data?.data ?? emptyRows };
};

export const useImportDSPClients = () => {
  const queryClient = useQueryClient();
  const orgId = useAppSelector((state) => state.user.organization_id);

  return useMutation({
    mutationFn: async (profileIds: string[]) =>
      await apiClient.importDSPClients({ org: orgId, profile_ids: profileIds }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [DSP_CLIENT_PREVIEW_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: ["dspProfiles"] });
    },
  });
};
